var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialIcon11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28.062,
    height: 24,
    viewBox: "0 0 28.062 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1863",
    "data-name": "Rectangle 1863",
    width: 28.062,
    height: 24,
    fill: "#152c40"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3427",
    "data-name": "Group 3427",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3426",
    "data-name": "Group 3426",
    transform: "translate(0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11139",
    "data-name": "Path 11139",
    d: "M2.517,19.2a2.4,2.4,0,1,0,0,4.8,2.4,2.4,0,1,0,0-4.8m5.884,4H33.6V20H8.4ZM2.517,9.6A2.459,2.459,0,0,0,0,12a2.465,2.465,0,0,0,2.517,2.4A2.467,2.467,0,0,0,5.041,12,2.467,2.467,0,0,0,2.517,9.6m5.884,4H33.6V10.4H8.4ZM2.517,0A2.459,2.459,0,0,0,0,2.4,2.465,2.465,0,0,0,2.517,4.8,2.467,2.467,0,0,0,5.041,2.4,2.467,2.467,0,0,0,2.517,0M8.4,4H33.6V.8H8.4Z",
    fill: "#152c40",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIcon11);
export default __webpack_public_path__ + "static/media/social-icon11.7c944d15625ec64d655dd64768426240.svg";
export { ForwardRef as ReactComponent };